import React from "react"
import {Spinner} from "reactstrap";

const Loading = ({ className, props }) =>
  <div {...props} className={"w-100 py-5 flex-center " + className}>
    <Spinner color="primary"/>
  </div>

export default Loading
